import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import FacesDisplay from './FacesDisplay';
import FACES from '../../constants/faces';

function FacesDisplayContainer({ content }) {
  const faces = useMemo(
    () =>
      content
        .map((i, j) => new Array(i).fill(j))
        .flat()
        .map((i, j) => ({
          index: j,
          key: j,
          id: j,
          face: FACES[i],
        })),
    [content],
  );
  return <FacesDisplay faces={faces} />;
}

FacesDisplayContainer.propTypes = {
  content: PropTypes.array.isRequired,
};

export default FacesDisplayContainer;
